import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import type { IconGlyph } from '@ipfabric/ui-components/Icon/IconGlyph';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import './Badge.css';

export interface BadgeProps {
  children: ReactNode;
  className?: string;
  size?: 'xs' | 'sm' | 'base' | 'xl';
  variant?: 'normal' | 'outlined' | 'inversed';
  icon?: IconGlyph;
}

export const Badge: FC<BadgeProps> = ({
  className,
  size = 'xs',
  variant = 'normal',
  icon,
  children,
}) => (
  <div
    className={classNames(
      className,
      'ipf-badge',
      `ipf-badge--${size} text-${size}`,
      `ipf-badge--${variant}`,
    )}
  >
    {icon && <Icon className='ipf-badge__icon' size='sm' glyph={icon} />}
    {children}
  </div>
);
